import application from 'application/application';

const headers = localStorage.getItem('__authenticationToken__')
	? {
			Authorization: 'Bearer ' + localStorage.getItem('__authenticationToken__')
	  }
	: {};

function hasNull(target) {
	for (var member in target) {
		if (target[member] == null) return true;
	}

	return false;
}

function isEquivalent(a, b) {
	let aProps = Object.getOwnPropertyNames(a),
		bProps = Object.getOwnPropertyNames(b);

	if (aProps.length != bProps.length) {
		return false;
	}

	for (var i = 0; i < aProps.length; i++) {
		let propName = aProps[i];

		if (a[propName] != b[propName]) {
			return false;
		}
	}

	return true;
}

function customizeElement(el, elClass) {
	if ((el.element && el.element.classList[0]) != undefined) {
		let where = el.element.classList[0].slice(5);
		let span = document.createElement('span');
		let text = document.createTextNode(el.text);

		if (el.text.indexOf(where) > -1) span.classList.add(elClass);

		span.appendChild(text);

		return span;
	} else {
		return el.text;
	}
}

function getDescendantProp(obj, desc) {
	var arr = desc.split('.');

	while (arr.length) {
		obj = obj[arr.shift()];
	}

	return obj;
}

function setDescendantProp(obj, desc, value) {
	var arr = desc.split('.');

	while (arr.length > 1) {
		obj = obj[arr.shift()];
	}

	return (obj[arr[0]] = value);
}

function focusSearchField() {
	setTimeout(() => {
		const searchField = document.querySelector(
			'.select2-container--open .select2-search__field'
		);

		if (searchField) searchField.focus();
	}, 0);
}

function toggleEmptyDropdownSearch(scope, element, attr) {
	if (attr.hideSearchWhenEmpty == undefined || !attr.customDropClass) return;

	setTimeout(() => {
		const select2 = element.data('select2');

		if (!select2 || !select2.$dropdown) return;

		const shouldHideSearch = scope.$parent.$eval(attr.hideSearchWhenEmpty);
		const searchContainer = select2.$dropdown.find('.select2-search--dropdown');

		select2.$dropdown.toggleClass(
			`${attr.customDropClass}--empty`,
			Boolean(shouldHideSearch)
		);

		searchContainer.toggle(!shouldHideSearch);
	}, 0);
}

function toggleSearchClearButton(searchField, clearButton) {
	clearButton.css('display', searchField.val() ? 'flex' : 'none');
}

function addSearchClearButton(element, attr) {
	if (attr.showSearchClear == undefined || !attr.customDropClass) return;

	setTimeout(() => {
		const select2 = element.data('select2');

		if (!select2 || !select2.$dropdown) return;

		const searchContainer = select2.$dropdown.find('.select2-search--dropdown');
		const searchField = searchContainer.find('.select2-search__field');

		if (!searchField.length || !searchContainer.is(':visible')) return;

		let clearButton = searchContainer.find('.select2-search__clear-field');

		if (!clearButton.length) {
			clearButton = $(
				'<button type="button" class="select2-search__clear-field" aria-label="Limpar busca">&times;</button>'
			);

			searchContainer.append(clearButton);
		}

		clearButton.off('mousedown.searchClear click.searchClear');
		clearButton.on('mousedown.searchClear click.searchClear', event => {
			event.preventDefault();
			event.stopPropagation();

			searchField
				.val('')
				.trigger('input')
				.trigger('keyup')
				.focus();
			toggleSearchClearButton(searchField, clearButton);
		});

		searchField.off('input.searchClear keyup.searchClear');
		searchField.on('input.searchClear keyup.searchClear', () => {
			toggleSearchClearButton(searchField, clearButton);
		});

		toggleSearchClearButton(searchField, clearButton);
	}, 0);
}

function populateSelect(scope, attr, ngModel, element) {
	var objectData = {
		paginaAtual: 1,
		registrosPorPagina: -1,
		campos: '*'
	};

	if (attr.paramText && ngModel.$viewValue)
		setDescendantProp(objectData, attr.paramId, ngModel.$viewValue); //objectData[attr.paramId] = ngModel.$viewValue;

	$.extend(objectData, scope.watchToTrigger);

	if (scope.url)
		$.ajax({
			url: scope.url,
			data: objectData,
			dataType: 'json',
			headers: headers
		}).done(response => {
			let count = response.itens.length;

			response.itens.map(item => {
				let newOption = new Option(
					getDescendantProp(item, attr.paramText),
					getDescendantProp(item, attr.paramId),
					false,
					false
				);

				element.append(newOption);

				if (count > 1) {
					if (getDescendantProp(item, attr.paramId) == ngModel.$viewValue)
						element.val(ngModel.$viewValue).triggerHandler('change');
				} else element.triggerHandler('change');
			});
		});
}

application.directive('customSelect', [
	() => {
		// Sobrescreve as opções padrões do Select2 pelo fato da versão atual
		// da biblioteca conter um bug e não ter nenhum patch de correção.

		$.fn.select2.defaults.set('language', {
			inputTooLong: args => {
				let overChars = args.input.length - args.maximum;

				return `Apague ${overChars} caracter${overChars > 1 ? 'es' : ''}`;
			},
			inputTooShort: args => {
				let remainingChars = args.minimum - args.input.length;

				return `Digite ${remainingChars} ou mais caracteres`;
			},
			maximumSelected: args => {
				const maximumSelection = args.maximum;

				return `Você só pode selecionar ${maximumSelection} ite${
					maximumSelection > 1 ? 'ns' : 'm'
				}`;
			},
			searching: () => 'Buscando…',
			removeAllItems: () => 'Remover todos os itens',
			noResults: () => 'Nenhum resultado encontrado',
			loadingMore: () => 'Carregando mais…',
			errorLoading: () => 'Os resultados não puderam ser carregados.'
		});

		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				watchToTrigger: '=',
				url: '=',
				customWidth: '@'
			},
			priority: 1,
			link: (scope, element, attr, ngModel) => {
				let initialValue = scope.watchToTrigger;
				let openAfterBeforeOpen = false;

				if (attr.dynamic != undefined)
					ngModel.$render = () => {
						if (scope.url) {
							populateSelect(scope, attr, ngModel, element);
						} else element.val(ngModel.$viewValue).triggerHandler('change');
					};

				if (scope.url && attr.dynamic != undefined) {
					element.select2({
						placeholder: attr.placeholder,
						minimumInputLength: 1,
						containerCssClass: attr.customSelectClass,
						dropdownCssClass: attr.customDropClass,
						dropdownAutoWidth: attr.dropdownAutoWidth != undefined,
						ajax: {
							url: scope.url,
							dataType: 'json',
							quietMillis: 800,
							headers: headers,
							data: term => {
								var returnObject = {
									paginaAtual: term.page || 1,
									registrosPorPagina: 10,
									campos: '*'
								};

								if (attr.paramText)
									setDescendantProp(returnObject, attr.paramText, term.term);

								$.extend(returnObject, scope.watchToTrigger);

								return returnObject;
							},
							processResults: data => {
								return {
									results: data.itens,
									pagination: {
										more: data.itens.length > 0 && data.itens.length == 10
									}
								};
							},
							cache: true
						},
						templateResult: item => {
							return attr.customElementClass !== undefined
								? customizeElement(item, attr.customElementClass)
								: item.text;
						},
						templateSelection: item => {
							return attr.customElementClass !== undefined
								? customizeElement(item, attr.customElementClass)
								: item.text;
						},
						width: scope.customWidth || '100%',
						dropdownCss: {
							'min-width': scope.customWidth || '200px'
						},
						theme: attr.customSelectTheme
					});
				} else if (attr.notsearch === 'infinity') {
					element.select2({
						minimumResultsForSearch: Infinity,
						placeholder: attr.placeholder, // Placeholder Testar
						containerCssClass: attr.customSelectClass,
						dropdownCssClass: attr.customDropClass,
						dropdownAutoWidth: attr.dropdownAutoWidth != undefined,
						templateResult: item => {
							return attr.customElementClass !== undefined
								? customizeElement(item, attr.customElementClass)
								: item.text;
						},
						templateSelection: item => {
							return attr.customElementClass !== undefined
								? customizeElement(item, attr.customElementClass)
								: item.text;
						},
						width: scope.customWidth || '100%',
						dropdownCss: {
							'min-width': scope.customWidth || '200px'
						},
						theme: attr.customSelectTheme
					});

					if (attr.noData == undefined)
						populateSelect(scope, attr, ngModel, element);
				} else {
					element.select2({
						placeholder: attr.placeholder, // Placeholder Testar
						containerCssClass: attr.customSelectClass,
						dropdownCssClass: attr.customDropClass,
						dropdownAutoWidth: attr.dropdownAutoWidth != undefined,
						language: {
							noResults: () =>
								attr.noResultsText || 'Nenhum resultado encontrado'
						},
						templateResult: item => {
							return attr.customElementClass !== undefined
								? customizeElement(item, attr.customElementClass)
								: item.text;
						},
						templateSelection: item => {
							return attr.customElementClass !== undefined
								? customizeElement(item, attr.customElementClass)
								: item.text;
						},
						width: scope.customWidth || '100%',
						dropdownCss: {
							'min-width': scope.customWidth || '200px'
						},
						theme: attr.customSelectTheme
					});

					if (attr.noData == undefined)
						populateSelect(scope, attr, ngModel, element);
				}

				if (attr.$attr.placeholderStyle !== undefined) {
					const select2 = element.data('select2');

					const rendered =
						select2 &&
						select2.$container.find('.select2-selection__rendered')[0];

					if (rendered) {
						const applyPlaceholderStyle = () => {
							const placeholder = rendered.querySelector(
								'.select2-selection__placeholder'
							);

							if (placeholder) {
								placeholder.style.cssText = attr.placeholderStyle || '';
							}
						};

						const observer = new MutationObserver(applyPlaceholderStyle);

						observer.observe(rendered, {
							childList: true,
							subtree: true
						});

						const stopObservingStyle = attr.$observe(
							'placeholderStyle',
							applyPlaceholderStyle
						);

						applyPlaceholderStyle();

						scope.$on('$destroy', () => {
							observer.disconnect();
							stopObservingStyle();
						});
					}
				}

				if (
					attr.$attr.placeholderStyle !== undefined ||
					attr.$attr.placeholderHoverStyle !== undefined
				) {
					const select2 = element.data('select2');

					const selection =
						select2 && select2.$container.find('.select2-selection')[0];

					const rendered =
						selection &&
						selection.querySelector('.select2-selection__rendered');

					if (rendered) {
						const $selection = $(selection);
						let isHovered = selection.matches(':hover');

						const applyPlaceholderStyle = () => {
							const placeholder = rendered.querySelector(
								'.select2-selection__placeholder'
							);

							if (!placeholder) return;

							const normalStyle = attr.placeholderStyle || '';
							const hoverStyle = isHovered
								? attr.placeholderHoverStyle || ''
								: '';

							placeholder.style.cssText = `${normalStyle};${hoverStyle}`;
						};

						$selection.on('mouseenter.placeholderStyle', () => {
							isHovered = true;
							applyPlaceholderStyle();
						});

						$selection.on('mouseleave.placeholderStyle', () => {
							isHovered = false;
							applyPlaceholderStyle();
						});

						const observer = new MutationObserver(applyPlaceholderStyle);

						observer.observe(rendered, {
							childList: true,
							subtree: true
						});

						const stopObservingStyle = attr.$observe(
							'placeholderStyle',
							applyPlaceholderStyle
						);

						const stopObservingHoverStyle = attr.$observe(
							'placeholderHoverStyle',
							applyPlaceholderStyle
						);

						applyPlaceholderStyle();

						scope.$on('$destroy', () => {
							observer.disconnect();
							$selection.off('.placeholderStyle');
							stopObservingStyle();
							stopObservingHoverStyle();
						});
					}
				}

				if (attr.noSelectionTitle !== undefined) {
					const select2 = element.data('select2');

					const rendered = select2.$container.find(
						'.select2-selection__rendered'
					)[0];

					if (rendered) {
						const observer = new MutationObserver(() => {
							if (rendered.hasAttribute('title')) {
								rendered.removeAttribute('title');
							}
						});

						observer.observe(rendered, {
							attributes: true,
							attributeFilter: ['title']
						});

						removeSelectionTitle(element);

						scope.$on('$destroy', () => {
							observer.disconnect();
						});
					}
				}

				element.on('select2:opening', event => {
					if (openAfterBeforeOpen) {
						openAfterBeforeOpen = false;

						return;
					}

					if (!attr.customSelectBeforeOpen) return;

					const beforeOpen = scope.$parent.$eval(attr.customSelectBeforeOpen);

					if (beforeOpen && typeof beforeOpen.finally === 'function') {
						event.preventDefault();

						beforeOpen.finally(() => {
							setTimeout(() => {
								openAfterBeforeOpen = true;
								element.select2('open');
							}, 0);
						});
					}
				});

				element.on('select2:open', () => {
					$('.select2-results__options').on('mousedown', e => {
						if (e.button == 1) return false;
					});

					toggleEmptyDropdownSearch(scope, element, attr);
					addSearchClearButton(element, attr);

					if (attr.focusSearchOnOpen != undefined) focusSearchField();
				});

				element.on('change', function() {
					let finalValue;
					const [valueType, rawValue] =
						typeof this.value === 'string' && this.value.includes(':')
							? `${this.value}`.split(':')
							: [typeof this.value, this.value];

					if (valueType === 'number') finalValue = parseFloat(rawValue);
					else if (valueType === 'string') finalValue = rawValue;
					else if (valueType === 'object') finalValue = JSON.parse(rawValue);
					else if (valueType === 'date') finalValue = new Date(rawValue);

					scope.$apply('ngModel', () => {
						ngModel.$setViewValue(finalValue);
					});
				});

				if (scope.watchToTrigger)
					scope.$watch('watchToTrigger', (newValue, oldValue) => {
						if (
							!hasNull(newValue) &&
							newValue != oldValue &&
							!isEquivalent(newValue, initialValue)
						) {
							initialValue = newValue;

							setTimeout(() => {
								let newOption = new Option(attr.placeholder, '', false, false);

								element
									.empty()
									.append(newOption)
									.val('')
									.triggerHandler('change');

								setTimeout(() => {
									populateSelect(scope, attr, ngModel, element);
								});
							});
						}
					});
			}
		};
	}
]);

function removeSelectionTitle(element) {
	const select2 = $(element).data('select2');

	if (!select2) return;

	select2.$container.find('.select2-selection__rendered').removeAttr('title');
}
